export function OutlineMoonIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 13.5626C18.2552 16.678 15.4513 19 12.0974 19C8.17872 19 5 15.8213 5 11.9026C5 8.55355 7.31711 5.74478 10.4374 5C9.5758 6.04659 9.05494 7.39013 9.05494 8.86022C9.05494 12.2191 11.7809 14.9451 15.1398 14.9451C16.605 14.9451 17.9534 14.4242 19 13.5626Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
